import { render, staticRenderFns } from "./CmgMobileNutritionDetailsModal.vue?vue&type=template&id=46a5c0e7&scoped=true&lang=pug"
import script from "./cmg-mobile-nutrition-details-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-mobile-nutrition-details-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgMobileNutritionDetailsModal.vue?vue&type=style&index=0&id=46a5c0e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a5c0e7",
  null
  
)

export default component.exports